<template>
  <v-dialog
    v-model="$store.state.stateStream_quiz_show"
    max-width="960px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    persistent
  >
    <v-card
      ref="card"
      max-height="calc(100vh - 192px)"
      :tile="$vuetify.breakpoint.smAndDown"
    >
      <v-card-title class="purple white--text font-weight-bold justify-center">
        {{ $store.state.stateStream_quiz_info.name }}
      </v-card-title>
      <v-card-text ref="toTop" class="py-5 black--text">

        <v-form
          ref="form"
          :readonly="readonly"
        >
          <div
            v-for="(question, i) in $store.state.stateStream_quiz_info.question"
            :key="`quiz-${ i }`"
            class="mb-8"
          >
            <div
              v-if="question.top_title"
              class="text-body-1 py-2 px-2 font-weight-bold"
            >
              {{ question.top_title }}
            </div>

            <div
              v-if="question.type === 4"
              class="purple lighten-4 py-2 px-3 font-weight-bold"
            >
              {{ question.title }}
            </div>

            <template v-else>
              <div class="grey lighten-2 py-2 px-3 font-weight-bold">
                {{ question.title }}
              </div>

              <v-textarea
                v-if="question.type === 0"
                v-model="question.value"
                class="mt-4"
                :rules="[gc_rules.requiredPollText]"
                rows="3"
                auto-grow
                no-resize
                filled
                dense
              />

              <v-input
                v-else-if="question.type === 2"
                v-model="question.value"
                class="mt-4 px-0 px-md-4"
                :rules="[gc_rules.requiredPollCheckMin, gc_rules.requiredPollCheckMax]"
              >
                <template v-slot:default>
                  <div class="d-flex flex-column">
                    <v-checkbox
                      v-model="question.value"
                      v-for="(text, i2) in question.case"
                      :key="`quiz-case-${ i }-${ i2 }`"
                      :label="text"
                      :value="i2"
                      :rules="[gc_rules.requiredPollCheckMin, gc_rules.requiredPollCheckMax]"
                      hide-details
                      dense
                    />
                  </div>
                </template>
              </v-input>

              <v-radio-group
                v-else
                v-model="question.value"
                class="flex-column px-0 px-md-4"
                :rules="[gc_rules.requiredPollRadio]"
                :row="!question.orientation"
                dense
              >
                <v-radio
                  v-for="(text, i2) in question.case"
                  :key="`quiz-case-${ i }-${ i2 }`"
                  :label="text"
                  :value="i2"
                />

                <template v-slot:append>
                  <div
                    v-if="scored"
                    class="ml-n2"
                  >
                    <div :class="itemScore(question.answer, question.value)">
                      정답) {{ question.answer ? 'X' : '○' }}
                    </div>
                    <div v-if="question.details" class="px-1 pt-2 blue--text c-text-indent">
                      해설) {{ question.details }}
                    </div>
                  </div>
                </template>
              </v-radio-group>
            </template>

          </div>
        </v-form>

        <v-btn
          v-if="$store.state.stateStream_quiz_scored"
          @click="$store.state.stateStream_quiz_show = false"
          class="mt-5 mx-auto d-block"
          width="128px"
          outlined
        >닫기</v-btn>

        <v-btn
          v-else
          @click="submit"
          class="mt-5 mx-auto d-block"
          width="128px"
          :loading="$store.state.stateStream_quiz_requesting"
          outlined
        >정답확인</v-btn>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import env from '../../plugins/process.env'
import axios from '../../plugins/axios'

export default {
  name: 'StreamDialogQuiz',

  computed: {
    scored() {
      return this.$store.state.stateStream_quiz_scored
    },

    readonly() {
      return this.scored || this.$store.state.stateStream_quiz_requesting
    }
  },

  methods: {
    submit() {
      const valid = this.$refs.form.validate()
      if (valid) {
        return this.submit_axios()
      }
      const target = this.$refs.card.$el
      setTimeout(() => {
        target.querySelector('.error--text')?.scrollIntoView()
      }, 100)
    },
    submit_axios() {
      const it = this
      const info = this.$store.state.stateStream_quiz_info
      const params = {
        answer: info.question
          .map(item => item.value)
          .filter(v => v !== null)
      }

      this.$store.state.stateStream_quiz_requesting = true

      return axios({
        method: 'POST',
        baseURL: env.API_BASE_URL,
        url: `/api/v1/response_poll/${ info.id }`,
        params
      }).then( result => {
        const state = result.data.code

        if (state !== 200) { throw state }

        it.gm_alertOpen({
          text: '성공적으로 제출 되었습니다.',
          callback: () => it.quizScore()
        })
      }).catch(error => {
        it._api_error(`code: ${error}\nat: api_streamDialogSurveySubmit`)
      }).finally( () => {
        it.$store.state.stateStream_quiz_requesting = false
      })
    },

    quizScore() {
      this.$store.state.stateStream_quiz_scored = true
      console.log(this.$refs)
      this.$refs.toTop.scrollTo(0, 0)
    },

    itemScore(ans, val) {
      let str = 'px-1 font-weight-bold'

      if (!this.scored) { return str }

      return str += ans === val ?
        ' green--text' : ' red--text'
    }
  }
}
</script>

<style lang="sass" scoped>
.c-text-indent
  text-indent: -2.25rem
  margin-left: 2.25rem
  word-break: keep-all
  line-height: 1.25
  white-space: pre-line
</style>
